import bilAPI from "../api";

export const getFinalResultsFiles = ({ signal }) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get("/olympiad/final_results/", { signal })
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const postFinalResultsFiles = (body) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post("/olympiad/final_results/", body)
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};
export const checkFinalResultsFile = (uuid) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/olympiad/final_results/${uuid}/check/`)
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};
export const saveResultsFinalResultsFile = (uuid) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/olympiad/final_results/${uuid}/save_results/`)
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};
export const deleteFinalResultsFiles = (uuid) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .delete(`/olympiad/final_results/${uuid}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};
